import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { supabase } from "@/configs/supabase/config";

export const Route = createFileRoute("/_protected/_god-mode")({
  beforeLoad: async ({ context }) => {
    const { userId } = context as { userId: string };

    const sb_FromProfiles_Select = await supabase
      .from("profiles")
      .select("is_god_mode")
      .eq("id", userId)
      .single();

    if (!sb_FromProfiles_Select.data?.is_god_mode) {
      throw redirect({ to: "/", search: { denied: "god-mode" } });
    }
  },
  component: () => <Outlet />,
});
